import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, NgZone, Attribute, Directive, NgModule } from '@angular/core';
import { tuiZonefree, preventDefault } from '@taiga-ui/cdk/observables';
import { TuiDestroyService } from '@taiga-ui/cdk/services';
import { fromEvent, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Simple prevent default on event directive when you do not need anything
 * else on event and do not want to trigger change detection
 * @dynamic
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
let TuiPreventDefaultDirective = class TuiPreventDefaultDirective {
    constructor({ nativeElement }, ngZone, destroy$, eventName) {
        fromEvent(nativeElement, eventName, { passive: false })
            .pipe(tuiZonefree(ngZone), preventDefault(), takeUntil(destroy$))
            .subscribe();
    }
};
TuiPreventDefaultDirective.ɵfac = function TuiPreventDefaultDirective_Factory(t) { return new (t || TuiPreventDefaultDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵinjectAttribute('tuiPreventDefault')); };
TuiPreventDefaultDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiPreventDefaultDirective, selectors: [["", "tuiPreventDefault", ""]], features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])] });
TuiPreventDefaultDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: String, decorators: [{ type: Attribute, args: ['tuiPreventDefault',] }] }
];
TuiPreventDefaultDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(NgZone)),
    __param(2, Inject(TuiDestroyService)),
    __param(3, Attribute('tuiPreventDefault'))
], TuiPreventDefaultDirective);

let TuiPreventDefaultModule = class TuiPreventDefaultModule {
};
TuiPreventDefaultModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiPreventDefaultModule });
TuiPreventDefaultModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiPreventDefaultModule_Factory(t) { return new (t || TuiPreventDefaultModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiPreventDefaultDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiPreventDefault]',
                providers: [TuiDestroyService]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: String, decorators: [{
                type: Attribute,
                args: ['tuiPreventDefault']
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPreventDefaultModule, { declarations: [TuiPreventDefaultDirective], exports: [TuiPreventDefaultDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiPreventDefaultModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiPreventDefaultDirective],
                exports: [TuiPreventDefaultDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPreventDefaultDirective, TuiPreventDefaultModule };

//# sourceMappingURL=taiga-ui-cdk-directives-prevent-default.js.map